import { getArtistHubQueryOptions } from "@/features/artist-hub/artist-hub-query";
const SplitLoader = async ({
  context: {
    queryClient,
    locale
  }
}) => ({
  locale,
  hub: await queryClient.ensureQueryData(getArtistHubQueryOptions(locale))
});
export { SplitLoader as loader };